export function ActionFormSection({ title, children }) {
    return (
        <div className='section'>
            <h4>{title}</h4>
            {children}
        </div>
    );
}
